export const TOGGLE_CHECKED = "TOGGLE_CHECKED";
export const CLEAN_ALL_CHECKED = "CLEAN_ALL_CHECKED";
